<sb-card [loading]="loading">
  <div card-header>
    <b>{{ 'lang.globals.productCategory' | translate }}</b>
  </div>
  <div card-header-more>
    <button class="btn btn-primary" (click)="addProductCategory()">{{ 'lang.globals.edit' | translate }}</button>
  </div>
  <div card-fit>
    <table class="table">
      <thead>
      <tr>
        <th>{{ 'lang.globals.name' | translate }}</th>
        <th>{{ 'lang.channels.description' | translate }}</th>
        <th>{{ 'lang.globals.created' | translate }}</th>
        <th class="text-end">{{ 'lang.globals.actions' | translate }}</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let productCategory of productCategories; index as i; last as last">
        <td>
          <sb-comp-image-name-wrapper [image]="productCategory?.illustration?.url">
            <span firstLine>{{ productCategory?.name }}</span>
          </sb-comp-image-name-wrapper>
        </td>
        <td>{{ productCategory?.description }}</td>
        <td>
          <sb-comp-display-created [data]="productCategory"></sb-comp-display-created>
        </td>

        <td class="text-end">
          <button class="btn btn-danger ml-1" (click)="removeProductCategory(productCategory)">
            <sb-icon icon="trash"></sb-icon>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</sb-card>
